<template>
  <div>
    <wc-dialog
      :showDialog='showQuickCreate'
      title='Quick Create Client'
      icon='mdi-account'
      @cancel='cancelQuickCreate'
      @save='saveButton'
      :saveText='save_text'
      :disableButtons='!isFormValid'
      :loadingButtons='savingQuickCreate'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row dense>
          <v-col cols='12'>
            <v-checkbox
              label='Is this a company?'
              v-model='quickCreateContact.is_company'
            ></v-checkbox>
          </v-col>
          <v-col cols='12' v-if="quickCreateContact.is_company">
            <v-checkbox
              label='Create commercial contact?'
              v-model='has_commercial_contact'
            ></v-checkbox>
          </v-col>
          <v-col cols='12' :md="quickCreateContact.is_company ? '12' : '6'">
            <v-text-field
              :label="quickCreateContact.is_company ? 'Company name' : 'First name'"
              v-model='quickCreateContact.name'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6' v-if='!quickCreateContact.is_company'>
            <v-text-field
              label='Last name'
              v-model='quickCreateContact.last_name'
              :rules='[rules.required]'
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              label='Address'
              v-model='quickCreateContact.address'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='City'
              v-model='quickCreateContact.city'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='3'>
            <v-text-field
              label='Province'
              v-model='quickCreateContact.province'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='3'>
            <wc-postal-code-input
              v-model='quickCreateContact.postal'
            ></wc-postal-code-input>
          </v-col>
          <v-col cols='12' md='6'>
            <v-text-field
              label='Email'
              :rules='[rules.email]'
              prepend-icon='mdi-email'
              v-model='quickCreateContact.email'
            ></v-text-field>
          </v-col>
          <v-col cols='12' md='6'>
            <phone-number-field
              v-if='quickCreateContact.is_company'
              label='Main Phone'
              :activate='showQuickCreate'
              :phone='quickCreateContact.work_phone !== null ? quickCreateContact.work_phone : ""'
              icon='mdi-phone'
              @update='updatePhoneNumber'
            ></phone-number-field>
            <phone-number-field
              v-else
              label='Cell Phone'
              :activate='showQuickCreate'
              :phone='quickCreateContact.cell_phone !== null ? quickCreateContact.cell_phone : ""'
              icon='mdi-phone'
              @update='updatePhoneNumber'
            ></phone-number-field>
          </v-col>
          <v-col cols="12" md="6">
            <client-form-search v-if='!isCompany'
                v-model='quickCreateContact.works_for'
                label='Works for'
            />
          </v-col>
          <template v-if="quickCreateContact.is_company && has_commercial_contact">
            <div style="text-align: 'left'; border: 1px solid black">Commercial Contact</div>
            <v-col cols='12'>
                <v-checkbox label='Existing contact?' v-model='existing_contact'></v-checkbox>
            </v-col>
            <template v-if="existing_contact">
                <v-col cols='12' md='12'>
                <client-form-search
                    v-model='commercial_contact.contact'
                    label='Commercial Contact'
                />
            </v-col>
            </template>
            <template v-else>
                <v-col cols='12' md="6">
                    <v-text-field
                    label='First name'
                    v-model='commercial_contact_client.name'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='Last name'
                    v-model='commercial_contact_client.last_name'
                    ></v-text-field>
                </v-col>
                <v-col cols='12'>
                    <v-text-field
                    label='Address'
                    v-model='commercial_contact_client.address'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='City'
                    v-model='commercial_contact_client.city'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='3'>
                    <v-text-field
                    label='Province'
                    v-model='commercial_contact_client.province'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='3'>
                    <wc-postal-code-input
                    v-model='commercial_contact_client.postal'
                    ></wc-postal-code-input>
                </v-col>
                <v-col cols='12' md='6'>
                    <v-text-field
                    label='Email'
                    :rules='[rules.email]'
                    prepend-icon='mdi-email'
                    v-model='commercial_contact_client.email'
                    ></v-text-field>
                </v-col>
                <v-col cols='12' md='6'>
                    <phone-number-field
                    label='Main Phone'
                    :phone='commercial_contact_client.work_phone !== null ? commercial_contact_client.work_phone : ""'
                    icon='mdi-phone'
                    @update='updateCommContactPhoneNumber'
                    ></phone-number-field>
                </v-col>
            </template>
            <v-col cols='12' md='6'>
            <v-text-field
                label='Position'
                v-model='commercial_contact.position'
            ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <v-checkbox label="Is Main Contact?" v-model="commercial_contact.main_contact"></v-checkbox>
            </v-col>
        </template>


        </v-row>
      </v-form>
      <v-row dense>
          <v-simple-table dense>
            <tbody>
              <template v-for='client in suggested_clients'>
                <tr :key='client.id' @click='selectClient(client)' style="cursor: pointer;">
                  <td>
                    {{client.name_display}}
                  </td>
                  <td>
                    {{client.address}}
                  </td>
                  <td>
                    {{client.email}}
                  </td>
                  <td>
                    {{client.cell_phone}}
                  </td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
        </v-row>
    </wc-dialog>
    <wc-dialog
      :showDialog='show_confirm_selection'
      title='Confirm Client'
      body_text="Abandon Create and Select this Client?"
      icon='mdi-account'
      @cancel='show_confirm_selection=false'
      @save='confirmSelectClient'
      saveText="Yes"
    >
    </wc-dialog>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules';
import clientsAPI from '@/api/clients';
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput';
import PhoneNumberField from '@/components/forms/PhoneNumberField';

export default {
  name: 'quick-create-client',
  mixins: [formRules],
  props: {
    showQuickCreate: {
      required: true
    },
    initialData: {
      required: false,
      default: null
    }
  },
  data: () => ({
    commercial_contact: {contact: 0, is_main_contact: false, client: 0, position: ""},
    commercial_contact_client: {},
    existing_contact: true,
    has_commercial_contact: false,
    isFormValid: false,
    phone: '',
    isLoading: false,
    save_text: 'Check Client',
    selected_client: null,
    show_confirm_selection: false,
    checked: false,
    suggested_clients: [],
    savingQuickCreate: false,
    quickCreateContact: {
      name: '',
      last_name: '',
      is_company: false,
      address: ''
    }
  }),
  computed: {
    isCompany(){
        return this.quickCreateContact.is_company;
    }
  },
  watch: {
    showQuickCreate () {
      if (this.showQuickCreate && this.initialData) {
        this.quickCreateContact.name = 'name' in this.initialData ? this.initialData.name : '';
        this.quickCreateContact.last_name = 'last_name' in this.initialData ? this.initialData.last_name : '';
        if(this.initialData && this.initialData.cell_phone){
          this.quickCreateContact.cell_phone = this.initialData.cell_phone;
        }
        this.quickCreateContact.address = 'address' in this.initialData ? this.initialData.address : '';
        this.quickCreateContact.city = 'city' in this.initialData ? this.initialData.city : '';
        this.quickCreateContact.province = 'province' in this.initialData ? this.initialData.province : '';
        this.quickCreateContact.country = 'country' in this.initialData ? this.initialData.country : '';
        this.quickCreateContact.postal = 'postal_code' in this.initialData ? this.initialData.postal_code : '';
        this.quickCreateContact.email = 'email' in this.initialData ? this.initialData.email : '';
      }
    }
  },
  methods: {
    resetForm () {
      setTimeout(() => {
        this.$refs.form.reset();
      }, 100)
    },
    cancelQuickCreate () {
      this.$refs.form.reset();
      this.$emit('cancel');
    },
    saveButton(){
      if(this.checked){
        this.saveQuickCreate();
      }else{
        let phone = this.quickCreateContact.cell_phone;
        if(this.quickCreateContact.is_company === true){
          phone = this.quickCreateContact.work_phone;
        }
        this.savingQuickCreate = true;
        this.save_text = 'Create Client';
        this.checked = true;
        this.checkClient(phone, this.quickCreateContact.postal, this.quickCreateContact.email, this.quickCreateContact.address);
        this.savingQuickCreate = false;
      }
    },
    async checkClient(phone, postal_code, email, address){
      this.suggested_clients = await clientsAPI.checkClient(phone, postal_code, email, address);
    },
    async saveQuickCreate () {
      this.savingQuickCreate = true;
      let newClient = await clientsAPI.createClient(this.quickCreateContact);
      if(this.has_commercial_contact){
        if(!this.existing_contact){
            this.commercial_contact_client.works_for = newClient.id;
            let newCommercialContactClient = await clientsAPI.createClient(this.commercial_contact_client);
            this.commercial_contact.contact = newCommercialContactClient.id;
        }
        else{
            clientsAPI.updateClient({id: this.commercial_contact.contact, works_for: newClient.id});
        }
        this.commercial_contact.client = newClient.id;
        await clientsAPI.createClientContact(this.commercial_contact);
      }
      
      this.$emit('save', newClient);
      this.savingQuickCreate = false;
      this.checked = false;
    },
    selectClient(client){
      this.selected_client = client;
      this.show_confirm_selection = true;
    },
    confirmSelectClient(){
      this.$emit('updateClient', this.selected_client);
      this.show_confirm_selection = false;
      this.selected_client = null;
    },
    updatePhoneNumber(phone){
      if(this.quickCreateContact.is_company){
        this.quickCreateContact.work_phone = phone;
      }else{
        this.quickCreateContact.cell_phone = phone;
      }
    },
    updateCommContactPhoneNumber(phone){
        this.commercial_contact_client.cell_phone = phone;
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput,
    'phone-number-field': PhoneNumberField,
    'client-form-search': () => import('@/modules/clients/components/ClientFormSearch'),
  }
}
</script>
